import { SensorRecord } from './sensorRecord.model';

export class RecordDto extends SensorRecord {
    formattedDate: string;
    formattedTime: string;
    batteryPercentage: number;
    parameterValue: ParameterValue;
    windSpeed: number;
    windDir: number;
    imgSrc?: string;
}

export class BatteryStatus {
    deviceId: string;
    deviceName: string;
    formattedDate?: string;
    formattedTime?: string;
    batteryPercentage: number;
    endPointId?: string;
    endPointName: string;
    imgSrc?: string;
    timestamp: number;
    signalStrength?: number;
    batteryCharging?: boolean;
    powerState?: string;
}
  
export class RecordDtoWithPolyogns extends RecordDto {
    polygons?: NodePolygon[];
    value?: number;
}

export interface NodePolygon{
    color: string;
    parameterValue: number;
    windSpeed: number;
    windFrequency: number;
    windAngleSpread1: number;
    windAngleSpread2: number;
}

export interface ParameterValue {
    name: string;
    value: number;
    color?: string;
}